
































































































































import { Component, Prop, Vue, Watch } from "@/shared/vuepack";
import { useHsabExpenseEvidenceShoeboxStore } from "@/employee/store/hsabExpenseEvidenceShoebox";
import { useThemeStore } from "@/shared/store/theme";
import { formatMMMDateString } from "@/shared/dateString";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import Paginator from "@/shared/components/ui/Paginator.vue";
import {
  HsabExpenseEvidenceShoeboxResponse,
  HsabExpenseFormMode,
} from "@/shared/types";
import _ from "lodash";
import { useHsabExpenseFormStore } from "@/employee/store/hsabExpenseForm";
import HsabExpenseEvidenceShoebox
  from "@/employee/components/landing-pages/hsabank/expense/HsabExpenseEvidenceShoebox.vue";

@Component({
  components: { HsabExpenseEvidenceShoebox, Paginator, GenericLoadingSpinner }
})
export default class HsabExpenseEvidenceShoeboxModal extends Vue {
  hsabExpenseFormStore = useHsabExpenseFormStore();
  shoeboxStore = useHsabExpenseEvidenceShoeboxStore();
  themeStore = useThemeStore();
  showExpenseModal = false;
  checkedIds = [];
  stagedFilesForUpload?: File[] | null;
  tempShoeboxEvidence: HsabExpenseEvidenceShoeboxResponse[] = [];
  fileToDelete: HsabExpenseEvidenceShoeboxResponse = null;
  showDeleteConfirmationModal = false;

  mounted () {
    this.shoeboxStore.loadPage(1);
  }

  @Watch("hsabExpenseFormStore.modalMode")
  OnExpenseFormModeChanged () {
    if (this.hsabExpenseFormStore.modalMode === HsabExpenseFormMode.none) {
      this.closeExpenseModal();
    }
  }

  get isModalOpen (): boolean {
    return this.shoeboxStore.isModalOpen;
  }

  get selectAnyReceiptsText (): string {
    if (this.shoeboxStore.isBrowsingUploadedFiles) {
      return "Select any receipts you want to add to your expense.";
    } else {
      return "Select any receipts you want to use to create an expense.";
    }
  }

  get showAddToExpenseButton (): boolean {
    return this.shoeboxStore.isBrowsingUploadedFiles;
  }

  get showShoeboxUploader (): boolean {
    return !this.shoeboxStore.isBrowsingUploadedFiles;
  }

  get currentPage () {
    return this.shoeboxStore.currentPageNumber;
  }

  get pageCount () {
    return this.shoeboxStore.totalPageCount;
  }

  get hasPages () {
    return this.shoeboxStore.totalPageCount > 0;
  }

  get loading () {
    return this.shoeboxStore.isCurrentPageLoading || this.isUploadingFiles;
  }

  get items () {
    _.each(this.shoeboxStore.currentPageItems, x => {
      x.isChecked = _.some(this.checkedIds, id => id === x.hsabExpenseEvidenceShoeboxId);
    });
    return this.shoeboxStore.currentPageItems;
  }

  clearShoeboxImagesCheckboxes (): void {
    if (!this.shoeboxStore.isBrowsingUploadedFiles) {
      this.hsabExpenseFormStore.checkedShoeboxExpenseEvidence = [];
    }
    this.checkedIds = [];
    this.tempShoeboxEvidence = [];
  }

  onSwitchPage (pageNumber: number) {
    this.shoeboxStore.loadPage(pageNumber);
  }

  closeModal () {
    this.clearShoeboxImagesCheckboxes();
    this.shoeboxStore.closeShoeboxModal();
  }

  get closeButtonText (): string {
    if (this.shoeboxStore.isBrowsingUploadedFiles) {
      return "Back";
    } else {
      return "Close";
    }
  }

  closeExpenseModal () {
    this.clearShoeboxImagesCheckboxes();
  }

  createExpense () {
    this.shoeboxStore.closeShoeboxModal();
    this.checkedIds = [];
    this.hsabExpenseFormStore.updateModalMode(HsabExpenseFormMode.createOrEdit);
  }

  addToExpense () {
    const target = this.hsabExpenseFormStore.checkedShoeboxExpenseEvidence;
    const existingIds = new Set(target.map(x => x.hsabExpenseEvidenceShoeboxId));
    const toAdd = this.tempShoeboxEvidence.filter(x => !existingIds.has(x.hsabExpenseEvidenceShoeboxId));
    target.push(...toAdd);
    if (!this.hsabExpenseFormStore.expenseForm.hsabExpenseEvidenceShoeboxIds) {
      this.hsabExpenseFormStore.expenseForm.hsabExpenseEvidenceShoeboxIds = [];
    }
    this.hsabExpenseFormStore.expenseForm.hsabExpenseEvidenceShoeboxIds.push(..._.map(toAdd, x => x.hsabExpenseEvidenceShoeboxId));
    this.clearShoeboxImagesCheckboxes();
    this.shoeboxStore.closeShoeboxModal();
  }

  openFile (item: HsabExpenseEvidenceShoeboxResponse) {
    this.shoeboxStore.OpenAttachment(item.hsabExpenseEvidenceShoeboxId);
  }

  get fileToDeleteFileName (): string {
    return this.fileToDelete ? this.fileToDelete.displayFileName : "";
  }
  onConfirmDeleteFile (item: HsabExpenseEvidenceShoeboxResponse) {
    this.fileToDelete = item;
    this.showDeleteConfirmationModal = true;
  }
  closeDeleteConfirmationModal () {
    this.fileToDelete = null;
    this.showDeleteConfirmationModal = false;
  }
  onDeleteFile () {
    if (this.fileToDelete)  {
      this.shoeboxStore.deleteShoeboxFile(this.fileToDelete.hsabExpenseEvidenceShoeboxId)
        .then(() => this.shoeboxStore.loadPage(1))
        .finally(() => {
          this.closeDeleteConfirmationModal();
        });
    }
  }

  onCheckedChanged (isChecked: boolean, item: HsabExpenseEvidenceShoeboxResponse) {
    if (isChecked) {
      this.checkedIds.push(item.hsabExpenseEvidenceShoeboxId);
      if (this.shoeboxStore.isBrowsingUploadedFiles) {
        this.tempShoeboxEvidence.push(item);
      } else {
        this.hsabExpenseFormStore.checkedShoeboxExpenseEvidence.push(item);
      }
    } else {
      this.checkedIds = _.filter(this.checkedIds, x => x !== item.hsabExpenseEvidenceShoeboxId);
      if (!this.shoeboxStore.isBrowsingUploadedFiles) {
        this.hsabExpenseFormStore.checkedShoeboxExpenseEvidence =
            _.filter(this.hsabExpenseFormStore.checkedShoeboxExpenseEvidence, x => x.hsabExpenseEvidenceShoeboxId !== item.hsabExpenseEvidenceShoeboxId);
      }
      this.tempShoeboxEvidence = _.filter(this.tempShoeboxEvidence, x => x.hsabExpenseEvidenceShoeboxId !== item.hsabExpenseEvidenceShoeboxId);
    }
  }

  formatDateForDisplay (date) {
    return formatMMMDateString(date);
  }
  isUploadingFiles = false;
  async addFile (files) {
    this.stagedFilesForUpload = files;
    if (this.stagedFilesForUpload && this.stagedFilesForUpload.length > 0) {
      this.isUploadingFiles = true;
      await this.shoeboxStore.uploadShoeboxFile(this.stagedFilesForUpload)
        .finally(() => this.isUploadingFiles = false);
      await this.shoeboxStore.loadPage(1);
    }
    this.stagedFilesForUpload.length = 0;
  }
}
